import Vue from 'vue';
import dayjs from 'dayjs';
import { bootstrap } from 'vue-gtag';

const expiryTime = dayjs().add(1, 'month').toDate();

export default {
    checkCookieConsent({ commit, getters }) {
        const consent = Vue.$cookies.get('cookie_consent');
        const cookieConsent = getters['getCookieBannerStatus'] && consent === null;

        if (consent) {
            // Initialise the GTM and GA after a user has consented to us collecting cookies.
            bootstrap().then((gtag) => {});
            Vue.gtm.enable(true);
        }

        commit('setDisplayingCookieBanner', cookieConsent);
    },
    acceptCookieConsent({ commit }) {
        Vue.$cookies.set('cookie_consent', true, expiryTime);
        commit('setDisplayingCookieBanner', false);

        // Initialise the GTM and GA after a user has consented to us collecting cookies.
        bootstrap().then((gtag) => {});
        Vue.gtm.enable(true);
    },
    rejectCookieConsent({ commit }) {
        Vue.$cookies.set('cookie_consent', false, expiryTime);
        commit('setDisplayingCookieBanner', false);
    }
};
